// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"682c4708","239":"33ce168b","240":"5aa4ef30","419":"58d02eb6","455":"0efd898e","559":"a56aafae","633":"cff67ce2","700":"377eac89","977":"4cde3954"}[chunkId] + ".chunk.js";
};